module.exports = function PickupConfirmation($rootScope,$window,$location,$stateParams,RescheduleDeliveryService) {
    return {
        restrict: 'E',
        scope: true,
        
        template: require('./pickupconfirmation-template.html'),
        link(scope) {
            scope.loading = false;
            scope.showPickUpConfirmation = false;
            scope.showInvalidResponse = false;
            $rootScope.orderNumber = $stateParams.ordernumber;

            RescheduleDeliveryService.OrdersReschedule($rootScope.orderNumber).then((response) => {
                if (response == undefined || response.ErrorMessage != null) {
                    scope.showInvalidResponse = true;
                }
                else{
                    scope.showPickUpConfirmation = true;
                    scope.reschDetails = response;
                    scope.isGuestOrder = scope.reschDetails.IsGuest;
                    var urlParts = scope.reschDetails.GetDirection.split('/');
                    scope.extractedUrlPart = '/' + urlParts.slice(-2).join('/');
                }
            })
            .catch(() => {
                scope.showInvalidResponse = true;
            });
        
            scope.redirectToDirection = function() {
                $location.url(scope.extractedUrlPart);
            };

            var backEvent = function (event) {
                history.pushState(null, null, window.location.href); //Capture the initial state of the page and push it
            };
            history.pushState(null, null, window.location.href); //Capture page's initial state

            $window.addEventListener('popstate', backEvent, true)

            $rootScope.$on("$locationChangeStart",function()
            {   if(backEvent) {
                    $window.removeEventListener('popstate', backEvent, true); 
                } backEvent = null;
            });

        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/pickupconfirmation/pickupconfirmation-directives.js
 **/